import {
    UPDATEUSERWITHDRWALCOUNT_SUCCESS,
    UPDATEUSERWITHDRWALCOUNT_FAILED,
    RESET_UPDATEUSERWITHDRWALCOUNT,
    LOADING_UPDATEUSERWITHDRWALCOUNT,
    NETWORK_ERROR_UPDATEUSERWITHDRWALCOUNT,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_UPDATEUSERWITHDRWALCOUNT:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case UPDATEUSERWITHDRWALCOUNT_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case UPDATEUSERWITHDRWALCOUNT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_UPDATEUSERWITHDRWALCOUNT:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_UPDATEUSERWITHDRWALCOUNT:
            return (state = initialState);
        default:
            return state;
    }
};
